import storage from "./storage";
import { unidentify } from "./unidentify";

export const reset = () => {
  unidentify();
  storage.clear();
  dispatchEvent(new Event("storage"));
};
